import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import { useEffect, useState } from 'react';

const Label = styled.span`
    color: #fff;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.15px;
`;

function CircularProgressWithLabel(props: CircularProgressProps & { value: number }) {
    return (
        <>
            <CircularProgress
                {...props}
                sx={{
                    color: theme => theme.colors.white,
                }}
            />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <Label>{`${Math.round(props.value)}%`}</Label>
            </Box>
        </>
    );
}

export function CircularWithValueLabel({
    totalDuration = 7000,
    totalProgress = 99,
    size,
}: {
    totalDuration?: number;
    totalProgress?: number;
    size: string;
}) {
    const [progress, setProgress] = useState(1);
    const interval = totalDuration / totalProgress;

    useEffect(() => {
        const intervalId = setInterval(() => {
            setProgress(oldProgress => {
                if (oldProgress < totalProgress) {
                    return Math.min(oldProgress + 1, totalProgress);
                } else {
                    clearInterval(intervalId);
                    return totalProgress;
                }
            });
        }, interval);

        return () => {
            clearInterval(intervalId);
        };
    }, [totalProgress, interval]);

    return <CircularProgressWithLabel value={progress} size={size} />;
}
